var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayEds)?_c('eds-create',{ref:"edsCreateDialog",on:{"mounted":_vm.onMountedEdsCreate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }